// backend/src/lib/dropdown-mobile-fix.js

/**
 * Fix para dropdowns de DaisyUI en iOS/movil
 *
 * PROBLEMA:
 * - DaisyUI usa :hover y :focus-within para mostrar dropdowns
 * - iOS Safari/Chrome no siempre maneja bien :focus-within en no-form controls
 * - :hover no existe en tactil
 *
 * SOLUCION:
 * - Toggle manual con clase 'dropdown-open'
 * - Click fuera cierra el dropdown
 * - Compatible con HTMX (delegacion de eventos)
 * - Funciona en desktop y movil
 */

export function initDropdownMobileFix() {
  // Guard: solo inicializar una vez
  if (window.__dropdownMobileFixBound) return;
  window.__dropdownMobileFixBound = true;

  let currentOpenDropdown = null;

  const closeCurrentDropdown = () => {
    if (currentOpenDropdown) {
      currentOpenDropdown.classList.remove('dropdown-open');
      currentOpenDropdown = null;
    }
  };

  const toggleDropdown = (dropdownEl) => {
    if (currentOpenDropdown === dropdownEl) {
      closeCurrentDropdown();
      return;
    }

    closeCurrentDropdown();
    dropdownEl.classList.add('dropdown-open');
    currentOpenDropdown = dropdownEl;
  };

  /**
   * Delegacion de eventos en document.body
   * - Funciona incluso si HTMX reemplaza el DOM
   * - Un solo listener (performance)
   */
  document.body.addEventListener('click', (evt) => {
    const target = evt.target;

    // 1) click en trigger de dropdown
    const dropdownTrigger = target.closest('.dropdown > button, .dropdown > label, .dropdown > .btn');
    if (dropdownTrigger) {
      const dropdown = dropdownTrigger.closest('.dropdown');
      if (dropdown) {
        evt.preventDefault();
        evt.stopPropagation();
        toggleDropdown(dropdown);
        return;
      }
    }

    // 2) click dentro de dropdown-content
    const dropdownContent = target.closest('.dropdown-content');
    if (dropdownContent) {
      // En iOS, cerrar demasiado pronto puede impedir aplicar el cambio
      // de checkboxes/radios (ej: menu de columnas).
      const isToggleControl = target.closest('input[type="checkbox"], input[type="radio"]');
      if (isToggleControl) return;

      // Si es un link o boton que debe navegar/ejecutar, dejamos que funcione
      const isActionable = target.closest('a, button, input, select, textarea');
      if (isActionable) {
        // Micro-delay para que la accion del click se procese
        setTimeout(closeCurrentDropdown, 50);
      }

      return;
    }

    // 3) click fuera => cerrar
    const clickedInsideDropdown = target.closest('.dropdown');
    if (!clickedInsideDropdown) {
      closeCurrentDropdown();
    }
  }, true);

  if (window.htmx) {
    document.body.addEventListener('htmx:afterSwap', () => {
      closeCurrentDropdown();
    });

    document.body.addEventListener('htmx:afterSettle', () => {
      document.querySelectorAll('.dropdown-open').forEach((el) => {
        if (!el.querySelector('.dropdown-content')) {
          el.classList.remove('dropdown-open');
        }
      });
    });
  }

  document.addEventListener('keydown', (evt) => {
    if (evt.key === 'Escape' || evt.key === 'Esc') {
      closeCurrentDropdown();
    }
  });

  console.log('Dropdown mobile fix initialized');
}

// Auto-init si se importa como modulo
if (typeof window !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDropdownMobileFix);
  } else {
    initDropdownMobileFix();
  }
}
